import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  OrderWrapper,
  MedDetailsWrap,
  MedSubBtn,
  BottomWrap,
} from "../PickerOrder/PickerOrder.style";
import "../PickerOrder/PickerOrder.css";
import { Input, Button, message } from "antd";
import {
  fetchMissingMedDetailsThunk,
  saveMissingMedicineDetails,
  confirmMissingMedicineDetailsThunk,
} from "../../redux/PickerOrder/Action";
import IncrementDecrementInput from "../../components/IncrementDecrementInput/IncrementDecrementInput";
import packageIcon from "../../assets/icons/package.png";
import { ROLES, warehouseId } from "../../constants/index";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import { Dialog } from "@material-ui/core";
import {
  Button as ButtonNew,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import OrderCard from "./SubComponent/OrderCard";
export class AdminPicker extends Component {
  state = {
    orderId: "",
    isSearched: false,
    allList: [],
    missingMedList: [],
    missingMedsModal: false,
  };

  componentDidMount() {
    if (
      this.props.userInfo &&
      this.props.userInfo.role &&
      !this.props.userInfo.role.find(
        (o) => o.roleName === ROLES.ADMIN_PICKER_ROLE
      )
    ) {
      message.error("Please contact picker admin to process this order");
      this.props.history.push("/markorder");
    } else {
      this.fetchMissingMedDetails();
    }
  }

  fetchMissingMedDetails = () => {
    if (this.props.userInfo?.warehouseIdList?.length > 0) {
      message.loading("Loading data...", 0);
      this.props
        .fetchMissingMedDetailsThunk({
          access_token: this.props.access_token,
          warehouseId: warehouseId,
          history: this.props.history,
        })
        .then(() => {
          if (this.props.pickerDetails?.missingMedsError) {
            message.destroy();
            message.error(this.props.pickerDetails.missingMedsError);
          } else if (this.props.pickerDetails?.missingMeds?.length >= 0) {
            this.setState(
              {
                missingMedList: this.filterDataByOrderId(
                  this.props.pickerDetails.missingMeds
                ),
                allList: this.filterDataByOrderId(
                  this.props.pickerDetails.missingMeds
                ),
              },
              () => {
                message.destroy();
              }
            );
          } else {
            message.destroy();
          }
        });
    } else {
      message.error("Please logout and login again");
    }
  };

  getOrderIds = (arr) => {
    let finalArr = [];
    for (let i in arr) {
      let order = arr[i];
      if (finalArr.indexOf(order.orderId) === -1) {
        finalArr.push(order.orderId);
      }
    }
    return finalArr;
  };

  getProductCodes = (arr) => {
    let finalArr = [];
    for (let i in arr) {
      let med = arr[i];
      if (finalArr.indexOf(med.productCode) === -1) {
        finalArr.push(med.productCode);
      }
    }
    return finalArr;
  };

  filterDataByOrderId = (arr) => {
    let orderSortedArray = [];
    let allOrderIds = this.getOrderIds(arr);
    if (allOrderIds?.length > 0) {
      for (let i in allOrderIds) {
        let orderId = allOrderIds[i];
        let medArr = [];
        for (let j in arr) {
          let order = arr[j];
          if (order.orderId === orderId) {
            medArr.push(order);
          }
        }
        let medList = [];
        let allProductCodes = this.getProductCodes(medArr);
        allProductCodes.map((f) => {
          let tempArray = [];
          medArr.map((e) => {
            if (e.productCode === f) {
              e.ogQty = e.quantity;
              tempArray.push(e);
            }
          });
          medList.push({
            name: tempArray[0].name,
            batches: tempArray,
            productCode: tempArray[0].productCode,
          });
        });
        medList = medList.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
        orderSortedArray.push({ orderId: medArr[0].orderId, MedList: medList });
      }
    }
    return orderSortedArray;
  };

  getFilteredDetails = () => {
    if (!this.state.orderId) {
      message.error("Please enter order id");
    } else {
      this.setState({ isSearched: !this.state.isSearched }, () => {
        if (this.state.isSearched) {
          let filteredList = [];
          for (let i in this.state.allList) {
            let order = this.state.allList[i];
            if (Number(order.orderId) === Number(this.state.orderId)) {
              filteredList.push(order);
              break;
            }
          }
          this.setState({ missingMedList: filteredList });
        } else {
          this.setState({ missingMedList: this.state.allList, orderId: "" });
        }
      });
    }
  };

  editMedDetails = (e, isActive) => {
    let arr = this.state.missingMedList;
    arr.map((f) => {
      if (f.orderId === e.orderId) {
        e.activeMed = isActive;
      }
    });
    this.setState({ missingMedList: arr }, () => {
      if (!isActive) {
        let finalArr = [];
        let batchesArr = this.getAllBatches(e.MedList);
        if (batchesArr?.length > 0) {
          for (let i in batchesArr) {
            let batch = batchesArr[i];
            if (batch.quantity !== batch.ogQty) {
              let newBatch = {};
              newBatch.active = batch.quantity ? true : false;
              newBatch.batchNumber = batch.batchNumber;
              newBatch.id = batch.id;
              newBatch.name = batch.name;
              newBatch.orderId = batch.orderId;
              newBatch.productCode = batch.productCode;
              newBatch.quantity = batch.quantity;
              newBatch.warehouseId = warehouseId;
              newBatch.invoiceBatchtId = batch.invoiceBatchtId;
              finalArr.push(newBatch);
            }
          }
        }
        if (finalArr?.length > 0) {
          let data = {
            access_token: this.props.access_token,
            missingMedicineDetailsList: finalArr,
            history: this.props.history,
          };
          message.loading("Saving...", 0);
          this.props.saveMissingMedicineDetails(data).then(() => {
            message.destroy();
            if (this.props.pickerDetails?.saveMedsFailure) {
              message.error(this.props.pickerDetails.saveMedsFailure);
            } else {
              this.fetchMissingMedDetails();
            }
          });
        } else {
          message.error("No change detected");
        }
      }
    });
  };

  getAllBatches = (meds) => {
    let finalArr = [];
    for (let i in meds) {
      let med = meds[i];
      finalArr.push(...med.batches);
    }
    return finalArr;
  };

  pickedMeds = (arr) => {
    let finalArr = [];
    let batchesArr = this.getAllBatches(arr.MedList);
    if (batchesArr?.length > 0) {
      for (let i in batchesArr) {
        let batch = batchesArr[i];
        let newBatch = {};
        newBatch.active = false;
        newBatch.batchNumber = batch.batchNumber;
        newBatch.id = batch.id;
        newBatch.name = batch.name;
        newBatch.orderId = batch.orderId;
        newBatch.productCode = batch.productCode;
        newBatch.quantity = 0;
        newBatch.warehouseId = warehouseId;
        newBatch.invoiceBatchtId = batch.invoiceBatchtId;
        finalArr.push(newBatch);
      }
    }
    let data = {
      access_token: this.props.access_token,
      missingMedicineDetailsList: finalArr,
      history: this.props.history,
    };
    message.loading("Saving...", 0);
    this.props.saveMissingMedicineDetails(data).then(() => {
      message.destroy();
      if (this.props.pickerDetails?.saveMedsFailure) {
        message.error(this.props.pickerDetails.saveMedsFailure);
      } else {
        this.fetchMissingMedDetails();
      }
    });
  };

  handleBatchEdit = (qty, orderKey, medKey, batchkey) => {
    let medicineList = this.state.missingMedList;
    medicineList[orderKey].MedList[medKey].batches[batchkey].quantity = qty;
    this.setState({ missingMedList: medicineList });
  };

  confirmMissingMedDetails = () => {
    message.loading("Confirming...", 0);
    this.setState({ missingMedsModal: false }, () => {
      let data = {
        access_token: this.props.access_token,
        warehouseId: warehouseId,
        history: this.props.history,
      };
      this.props.confirmMissingMedicineDetailsThunk(data).then(() => {
        message.destroy();
        if (this.props.pickerDetails?.confirmMedsError) {
          message.error(this.props.pickerDetails?.confirmMedsError);
        } else {
          message.success("Confirmed!");
          this.fetchMissingMedDetails();
        }
      });
    });
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.missingMedsModal}
          onClose={() => {
            this.setState({ missingMedsModal: false });
          }}
          fullWidth={true}
          maxWidth={"lg"}
        >
          <DialogTitle>
            Are you sure you want to confirm missing medicine details?
          </DialogTitle>
          <DialogActions>
            <ButtonNew
              onClick={() => this.setState({ missingMedsModal: false })}
              color="primary"
            >
              No
            </ButtonNew>
            <ButtonNew
              onClick={() => this.confirmMissingMedDetails()}
              variant="contained"
              color="primary"
            >
              Yes
            </ButtonNew>
          </DialogActions>
        </Dialog>
        <TitleWrapper title={"Admin Picker"} />
        <OrderWrapper>
          <div className="inputWrap">
            <Input
              type="number"
              placeholder="Enter Order Id"
              onChange={(e) => {
                this.setState({
                  orderId: e.target.value,
                });
              }}
              value={this.state.orderId}
            />
          </div>
          <div className="btnWrap">
            <Button
              onClick={() => {
                this.getFilteredDetails();
              }}
            >
              {this.state.isSearched ? "Clear" : "Search"}
            </Button>
          </div>
        </OrderWrapper>
        <div>
          {this.state.missingMedList?.length > 0 ? (
            <div>
              {this.state.missingMedList.map((e, i) => (
                <OrderCard
                  details={e}
                  ind={i}
                  pickedMeds={(e) => this.pickedMeds(e)}
                  handleBatchEdit={(qty, ind, medKey, j) =>
                    this.handleBatchEdit(qty, ind, medKey, j)
                  }
                  editMedDetails={(details, activeMed) =>
                    this.editMedDetails(details, activeMed)
                  }
                />
              ))}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              <span>No Medicines Found</span>
            </div>
          )}
        </div>
        {this.state.missingMedList.length > 0 && (
          <BottomWrap onClick={() => this.setState({ missingMedsModal: true })}>
            <div>Confirm Missing Meds</div>
          </BottomWrap>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
});

export default withRouter(
  connect(mapStateToProps, {
    fetchMissingMedDetailsThunk,
    saveMissingMedicineDetails,
    confirmMissingMedicineDetailsThunk,
  })(AdminPicker)
);
